/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMobileDevice,
    ReadOnlyMobileDeviceFromJSON,
    ReadOnlyMobileDeviceFromJSONTyped,
    ReadOnlyMobileDeviceToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20019
 */
export interface InlineResponse20019 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20019
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20019
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20019
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMobileDevice>}
     * @memberof InlineResponse20019
     */
    results: Array<ReadOnlyMobileDevice>;
}

export function InlineResponse20019FromJSON(json: any): InlineResponse20019 {
    return InlineResponse20019FromJSONTyped(json, false);
}

export function InlineResponse20019FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20019 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMobileDeviceFromJSON)),
    };
}

export function InlineResponse20019ToJSON(value?: InlineResponse20019 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMobileDeviceToJSON)),
    };
}


